import { PathParamKeys } from 'app/core/workflow/page-path/path-param-keys';
import { RecognizerHelper } from 'app/core/helpers/recognizer.helper';
import { BaseStatementPagePath } from 'app/core/workflow/page-path/statement-page-path/base-statement-page.path';

export class PersonalInfoChildComponentPath extends BaseStatementPagePath {
  public static path(): string {
    return `statement/:${PathParamKeys.statementId}/children/:${PathParamKeys.childId}/personal-info`;
  }

  public static regex(step?: number): RegExp {
    return this.componentRegex(this.path(), null, RecognizerHelper.isNumber(step) && String(step));
  }
}
